        import React from 'react';
        import { FiUpload, FiShoppingCart, FiArrowLeft,FiList,FiTrash,FiFilter,FiUser,FiEye,FiFolder,FiMoreVertical,FiMessageCircle,FiTag} from 'react-icons/fi';
        import Logo from './assets/logo2.png';
        import { useEffect, useRef, useState } from 'react';
        import AnalysisIco from './assets/analysis.png';
        import UploadIco from './assets/upload.png';
        import SearchIco from './assets/search.png';
        import SettingsIco from './assets/settings.png';
        import BackIco from './assets/back.png';
        import ResetIco from './assets/reset.png';




        const FlagUSA = () => (
          <svg width="24" height="16" viewBox="0 0 7410 3900">
            <rect width="7410" height="3900" fill="#b22234" />
            {[...Array(6)].map((_, i) => (
              <rect key={i} y={i * 600 + 300} width="7410" height="300" fill="#fff" />
            ))}
            <rect width="2964" height="2100" fill="#3c3b6e" />
          </svg>
        );

        const FlagPR = () => (
          <svg width="24" height="16" viewBox="0 0 7410 3900">
            <rect width="7410" height="3900" fill="#ed0000" />
            {[...Array(2)].map((_, i) => (
              <rect key={i} y={i * 1560 + 780} width="7410" height="780" fill="#fff" />
            ))}
            <polygon points="0,0 2964,1950 0,3900" fill="#0050f0" />
            <polygon points="1000,1950 1200,2150 900,2150" fill="#fff" />
          </svg>
        );

        const baseButtonStyle = {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '5px',
          padding: '5px',
          borderRadius: '5px',
          border: 'none',
          fontSize: '1em',
          fontWeight: 600,
          color: '#ffffff',
          boxSizing: 'border-box',
          overflowX: 'hidden',
          cursor: 'pointer',
          boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
          transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        };

        const VIEW_MODES = {
          CATEGORIES: 'categories',
          ITEMS: 'items',
        };

        // SHOP-130: hidden entirely (not just disabled) rather than removed, so
        // FileUploadModal/onOpenUploadModal stay wired for future re-enablement.
        const SHOW_RECEIPT_UPLOAD_BUTTON = false;

        const navBtnStyle = {
          background: '#f1f5f9',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          padding: '6px 10px',
          fontSize: '0.85em',
          cursor: 'pointer'
        };



        const primaryBtnStyle = {
          flex: 1,
          background: '#e6fffa',
          border: '1px solid #5eead4',
          borderRadius: '10px',
          padding: '10px',
          fontWeight: 'bold',
          cursor: 'pointer'
        };

        const secondaryBtnStyle = {
          flex: 1,
          background: '#f8fafc',
          border: '1px solid #e2e8f0',
          borderRadius: '10px',
          padding: '10px',
          cursor: 'pointer'
        };




        function CategoryHeader({
          translations,
          language,
          selectedCategoriesCount,
          shouldShowResults,
          formattedTotalPrice,
          storeTotals,
          isLoggedIn,
          profilePictureUrl,
          formatCurrency,
          isSearching,
          onToggleLanguage,
          onOpenUploadModal,
          onHandleBackToCategories,
          onHandleGoToList,
          onSearch,
          onHeightChange,
          onOpenFilter,
          viewMode,
          onOpenItemSearchModal,
          onOpenAskCopilot,
          onResetAll,
          onOpenWatchedItems,
          onOpenWatchedCategories,
          watchedItemsAlertCount = 0,
          sortByUnitPrice = false,
          onToggleSortByUnitPrice
        }) {
            const headerRef = useRef(null);
            const menuRef = useRef(null);

              useEffect(() => {
                if (!headerRef.current) return;

                const updateHeight = () => {
                  const height = headerRef.current.offsetHeight;
                  onHeightChange?.(height);
                };

                updateHeight();

                // Recalcular si cambia el layout
                const resizeObserver = new ResizeObserver(updateHeight);
                resizeObserver.observe(headerRef.current);

                return () => resizeObserver.disconnect();
              }, [onHeightChange]);

            // SHOP-16: falls back to the generic icon if the Google-hosted picture fails to load.
            const [avatarError, setAvatarError] = useState(false);
            useEffect(() => {
              setAvatarError(false);
            }, [profilePictureUrl]);

            // SHOP-17: profile menu, closes on outside click or Escape.
            const [isMenuOpen, setIsMenuOpen] = useState(false);
            useEffect(() => {
              if (!isMenuOpen) return;

              const handleClickOutside = (event) => {
                if (menuRef.current && !menuRef.current.contains(event.target)) {
                  setIsMenuOpen(false);
                }
              };
              const handleKeyDown = (event) => {
                if (event.key === 'Escape') {
                  setIsMenuOpen(false);
                }
              };

              document.addEventListener('mousedown', handleClickOutside);
              document.addEventListener('keydown', handleKeyDown);
              return () => {
                document.removeEventListener('mousedown', handleClickOutside);
                document.removeEventListener('keydown', handleKeyDown);
              };
            }, [isMenuOpen]);

            // SHOP-20: hover/click color feedback on menu items.
            const [hoveredItemKey, setHoveredItemKey] = useState(null);
            const [clickedItemKey, setClickedItemKey] = useState(null);
            const closeMenuTimeoutRef = useRef(null);

            useEffect(() => {
              if (!isMenuOpen) {
                setHoveredItemKey(null);
                setClickedItemKey(null);
                if (closeMenuTimeoutRef.current) {
                  clearTimeout(closeMenuTimeoutRef.current);
                  closeMenuTimeoutRef.current = null;
                }
              }
            }, [isMenuOpen]);

            useEffect(() => {
              return () => {
                if (closeMenuTimeoutRef.current) clearTimeout(closeMenuTimeoutRef.current);
              };
            }, []);

            const handleMenuItemClick = (key) => {
              // Delay closing so the click highlight has time to actually paint
              // and be seen, instead of racing the dropdown's unmount.
              setClickedItemKey(key);
              if (key === 'myWatchedItems') {
                onOpenWatchedItems?.();
              }
              if (key === 'myWatchedCategories') {
                onOpenWatchedCategories?.();
              }
              closeMenuTimeoutRef.current = setTimeout(() => {
                setIsMenuOpen(false);
              }, 150);
            };

            // SHOP-61: when one or more watched items are at/under the price-alert
            // threshold (SHOP-58/60), surface that count next to "My Watched Items"
            // and mirror it as a badge on the three-dot trigger below.
            const hasWatchedItemsAlert = watchedItemsAlertCount > 0;
            const profileMenuItems = [
              {
                key: 'myWatchedItems',
                icon: FiEye,
                label: hasWatchedItemsAlert
                  ? `${translations.myWatchedItems || 'My Watched Items'} (${watchedItemsAlertCount})`
                  : translations.myWatchedItems || 'My Watched Items',
                alert: hasWatchedItemsAlert,
              },
              { key: 'myWatchedCategories', icon: FiFolder, label: translations.myWatchedCategories || 'My Watched Categories' },
            ];

          return (
            <header
                ref={headerRef}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                maxWidth: '100vw',
                boxSizing: 'border-box',
                zIndex: 10,
                backgroundColor: '#ffffff',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                borderBottom: '2px solid #ddd',
                padding: '12px 14px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
              }}
            >

            {/* FILA 1 – Logo + Ahorros + Idioma */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }}
            >
              {/* Logo + Nombre */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px'
                }}
              >
                <img
                  src={Logo}
                  alt="ShopCopilot logo"
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '8px'
                  }}
                />

                <span
                  style={{
                    fontSize: '1.2rem',
                    fontWeight: 700,
                    color: '#0A2540'
                  }}
                >
                  Shop<span style={{ color: '#F97316' }}>Copilot</span>
                </span>
              </div>

              {/* Ahorros + Idioma */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                {/* Ícono de perfil (SHOP-16): decorativo desde SHOP-53, ya no abre el menú */}
                <div
                  title={isLoggedIn ? (translations.profile || 'Perfil') : (translations.signIn || 'Iniciar sesión')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    backgroundColor: '#f1f3f5',
                    border: '1px solid #ccc',
                    flexShrink: 0
                  }}
                >
                  {isLoggedIn && profilePictureUrl && !avatarError ? (
                    <img
                      src={profilePictureUrl}
                      alt={translations.profile || 'Perfil'}
                      onError={() => setAvatarError(true)}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  ) : (
                    <FiUser size={20} color="#64748b" />
                  )}
                </div>

                {/* Menú de tres puntos (SHOP-53): trigger del menú antes alojado en el ícono de perfil (SHOP-17) */}
                <div ref={menuRef} style={{ position: 'relative' }}>
                  <button
                    type="button"
                    onClick={() => setIsMenuOpen(prev => !prev)}
                    aria-haspopup="true"
                    aria-expanded={isMenuOpen}
                    title={translations.moreOptions || 'Más opciones'}
                    aria-label={
                      hasWatchedItemsAlert
                        ? `${translations.moreOptions || 'Más opciones'} (${translations.priceAlertPill || 'Price alert'}: ${watchedItemsAlertCount})`
                        : translations.moreOptions || 'Más opciones'
                    }
                    style={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      backgroundColor: '#f1f3f5',
                      border: '1px solid #ccc',
                      flexShrink: 0,
                      padding: 0,
                      cursor: 'pointer'
                    }}
                  >
                    <FiMoreVertical size={20} color="#64748b" />
                    {hasWatchedItemsAlert && (
                      <span
                        aria-hidden="true"
                        style={{
                          position: 'absolute',
                          top: '-2px',
                          right: '-2px',
                          minWidth: '16px',
                          height: '16px',
                          padding: '0 4px',
                          borderRadius: '999px',
                          backgroundColor: '#dc2626',
                          color: '#ffffff',
                          fontSize: '0.65em',
                          lineHeight: '16px',
                          fontWeight: 700,
                          textAlign: 'center',
                          border: '1.5px solid #ffffff',
                          boxSizing: 'border-box'
                        }}
                      >
                        {watchedItemsAlertCount > 9 ? '9+' : watchedItemsAlertCount}
                      </span>
                    )}
                  </button>

                  {isMenuOpen && (
                    <div
                      role="menu"
                      style={{
                        position: 'absolute',
                        top: '44px',
                        right: 0,
                        minWidth: '210px',
                        backgroundColor: '#ffffff',
                        borderRadius: '10px',
                        border: '1px solid #e2e8f0',
                        boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                        overflow: 'hidden',
                        zIndex: 20
                      }}
                    >
                      {profileMenuItems.map(({ key, icon: Icon, label, alert }) => (
                        <button
                          key={key}
                          type="button"
                          role="menuitem"
                          disabled={!isLoggedIn}
                          onClick={() => handleMenuItemClick(key)}
                          onMouseEnter={() => setHoveredItemKey(key)}
                          onMouseLeave={() => setHoveredItemKey(null)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            width: '100%',
                            padding: '10px 14px',
                            border: 'none',
                            backgroundColor: clickedItemKey === key
                              ? '#e0f2fe'
                              : hoveredItemKey === key
                              ? '#f1f5f9'
                              : 'transparent',
                            transition: 'background-color 0.12s ease',
                            textAlign: 'left',
                            fontSize: '0.9em',
                            color: !isLoggedIn ? '#94a3b8' : alert ? '#dc2626' : '#0F172A',
                            fontWeight: isLoggedIn && alert ? 700 : 400,
                            cursor: isLoggedIn ? 'pointer' : 'not-allowed',
                            opacity: isLoggedIn ? 1 : 0.6
                          }}
                        >
                          <Icon size={16} color={isLoggedIn && alert ? '#dc2626' : undefined} />
                          {label}
                        </button>
                      ))}
                      {/* SHOP-197: sibling of the SHOP-194 toggle (removed in SHOP-204) - same
                          client-only (localStorage), not-gated-on-isLoggedIn,
                          menu-stays-open behavior. */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '10px',
                          width: '100%',
                          padding: '10px 14px',
                          borderTop: '1px solid #e2e8f0',
                          boxSizing: 'border-box',
                          fontSize: '0.9em',
                          color: '#0F172A'
                        }}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <FiTag size={16} />
                          {translations.sortByUnitPriceLabel || 'Sort by unit price'}
                        </span>
                        <button
                          type="button"
                          role="switch"
                          aria-checked={sortByUnitPrice}
                          aria-label={translations.sortByUnitPriceLabel || 'Sort by unit price'}
                          onClick={() => onToggleSortByUnitPrice?.()}
                          style={{
                            position: 'relative',
                            width: '36px',
                            height: '20px',
                            borderRadius: '999px',
                            border: 'none',
                            backgroundColor: sortByUnitPrice ? '#0F766E' : '#94a3b8',
                            cursor: 'pointer',
                            padding: 0,
                            flexShrink: 0,
                            transition: 'background-color 0.15s ease'
                          }}
                        >
                          <span
                            style={{
                              position: 'absolute',
                              top: '2px',
                              left: sortByUnitPrice ? '18px' : '2px',
                              width: '16px',
                              height: '16px',
                              borderRadius: '50%',
                              backgroundColor: '#ffffff',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                              transition: 'left 0.15s ease'
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Botón idioma */}
                <button
                  onClick={onToggleLanguage}
                  aria-label={language === 'es' ? 'Change to English' : 'Cambiar a Español'}
                  title={language === 'es' ? 'Change to English' : 'Cambiar a Español'}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '44px',
                    height: '36px',
                    borderRadius: '10px',
                    backgroundColor: '#f1f3f5',
                    border: '1px solid #ccc',
                    cursor: 'pointer',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                    padding: 0
                  }}
                >
                  {language === 'es' ? <FlagPR /> : <FlagUSA />}
                </button>
              </div>
            </div>




              <div
                      style={{
                        display: 'flex',
                        gap: '12px',
                        flexWrap: 'wrap',
                        width: '100%',
                        boxSizing: 'border-box'
                      }}
                    >
                    {storeTotals && Object.keys(storeTotals).length > 0 && (
                      <div
                        style={{
                              display: 'flex',
                              flexWrap: 'nowrap',              // ❌ no wrap
                              overflowX: 'auto',               // ✅ scroll horizontal
                              gap: '12px',
                              marginTop: '8px',
                              paddingBottom: '6px',            // espacio para scrollbar
                              WebkitOverflowScrolling: 'touch',
                              scrollSnapType: 'x mandatory',
                       // Edge / IE
                        }}
                      >
                        {Object.entries(storeTotals).map(([store, total]) => (
                          <div
                            key={store}
                            style={{
                              flex: '0 0 auto',             // 👈 NO se estiran
                              minWidth: '130px',             // ancho consistente
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              background: '#eaf4ff',
                              padding: '10px 14px',
                              borderRadius: '12px',
                              fontWeight: 600,
                              color: '#004085',
                              whiteSpace: 'nowrap',
                               scrollSnapAlign: 'start',
                            }}
                          >
                            <span style={{ textTransform: 'capitalize' }}>{store}</span>
                            <span>{formatCurrency(total)}</span>
                          </div>
                        ))}
                      </div>
                    )}

                </div>
              {/* FILA 2 */}
              <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    flexWrap: 'wrap',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                >
 {shouldShowResults && !isSearching  && (
                    <button
                      onClick={onHandleBackToCategories}
                      style={{
                        ...baseButtonStyle,
                        backgroundColor: '#F0FDFA',   // fondo claro
                        color: '#0F766E',             // texto + ícono
                        border: '1px solid #99F6E4',
                        flex: '1 1 0',
                        minWidth: 0
                      }}
                    >
                     <img
                      src={BackIco}
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '8px'
                      }}
                    />
                    </button>
 )}
                {SHOW_RECEIPT_UPLOAD_BUTTON && (
                <button
                  onClick={onOpenUploadModal}
                  style={{
                    ...baseButtonStyle,
                    backgroundColor: '#F0FDFA',   // fondo claro
                    color: '#0F766E',             // texto + ícono
                    border: '1px solid #99F6E4',
                    flex: '1 1 0',
                    minWidth: 0
                  }}
                >
                    <img
                      src={UploadIco}
                      alt="ShopCopilot logo"
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '8px'
                      }}
                    />
                </button>
                )}

                {viewMode === VIEW_MODES.CATEGORIES && (
                    <button
                      onClick={onSearch}
                      disabled={isSearching || selectedCategoriesCount === 0 || shouldShowResults}
                      style={{
                        ...baseButtonStyle,
                        backgroundColor: '#ECFEFF',   // fondo claro
                        color: '#0369A1',             // texto + ícono
                        border: '1px solid #A5F3FC',
                               // 🔑 NO más flex:2
                        minWidth: 0,          // 🔑 evita corte
                        flex: '1 1 0',
                        opacity:
                          isSearching || selectedCategoriesCount === 0 || shouldShowResults
                            ? 0.6
                            : 1
                      }}
                    >
                      <img
                      src={AnalysisIco}
                      alt="ShopCopilot logo"
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '8px'
                      }}
                    />


                    </button>
                 )}


                 {viewMode === VIEW_MODES.CATEGORIES && (
                <button
                  onClick={onOpenItemSearchModal}
                  disabled={viewMode == VIEW_MODES.ITEMS}
                  title={translations.searchItems}
                  style={{
                    ...baseButtonStyle,
                    backgroundColor: '#F0FDFA',   // fondo claro
                    color: '#0F766E',             // texto + ícono
                    border: '1px solid #99F6E4',
                    minWidth: 0,
                    flex: '1 1 0',
                    opacity:
                      viewMode == VIEW_MODES.ITEMS
                        ? 0.6
                        : 1
                  }}
                >
                   <img
                  src={SearchIco}
                  alt="ShopCopilot logo"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px'
                  }}
                />
                </button>
                 )}

                 {/* SHOP-104: gated to Google-signed-in users, consistent with the
                     backend's Depends(get_current_user) gate on /copilot/ask - hidden
                     entirely (not just disabled) for anonymous users, matching the
                     watch-toggle buttons' idiom elsewhere in this app. */}
                 {viewMode === VIEW_MODES.CATEGORIES && isLoggedIn && (
                <button
                  onClick={onOpenAskCopilot}
                  disabled={viewMode == VIEW_MODES.ITEMS}
                  title={translations.askCopilot}
                  style={{
                    ...baseButtonStyle,
                    backgroundColor: '#F0FDFA',   // fondo claro
                    color: '#0F766E',             // texto + ícono
                    border: '1px solid #99F6E4',
                    minWidth: 0,
                    flex: '1 1 0',
                    opacity:
                      viewMode == VIEW_MODES.ITEMS
                        ? 0.6
                        : 1
                  }}
                >
                  <FiMessageCircle size={24} />
                </button>
                 )}

                    {viewMode === VIEW_MODES.ITEMS && (
                      <button
                        onClick={onResetAll}
                        title={language === 'es' ? 'Reiniciar selección' : 'Reset selection'}
                       style={{
                        ...baseButtonStyle,
                        backgroundColor: '#ECFEFF',   // fondo claro
                        color: '#0369A1',             // texto + ícono
                        border: '1px solid #A5F3FC',
                        flex: '1 1 0',
                        minWidth: 0,          // 🔑 evita corte
                      }}
                      >
                     <img
                      src={ResetIco}
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '8px'
                      }}
                      />
                      </button>
                    )}

            {viewMode === VIEW_MODES.CATEGORIES && (
                <button
                  onClick={onOpenFilter}
                  disabled={viewMode == VIEW_MODES.ITEMS}
                  aria-label={translations.settings}
                  style={{
                   ...baseButtonStyle,
                    backgroundColor: '#F0FDFA',   // fondo claro
                    color: '#0F766E',             // texto + ícono
                    border: '1px solid #99F6E4',
                    minWidth: 0,
                    flex: '1 1 0',
                    opacity:
                      viewMode == VIEW_MODES.ITEMS
                        ? 0.6
                        : 1
                  }}
                >
                  <img
                  src={SettingsIco}
                  alt=""
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px'
                  }}
                />
                </button>
            )}


              </div>

            </header>
          );
        }



        export default CategoryHeader;
